import { Products } from '@/shared/types/Billing';

export const getPlanName = ({
  hasFreeSubscription,
  hasTrialPlan,
  productId,
  products,
}: {
  hasFreeSubscription: boolean;
  hasTrialPlan: boolean;
  productId?: string;
  products?: Products;
}) => {
  const productName = products?.plan.find((plan) => plan.id === productId)?.name ?? '';

  if (!productName) {
    return hasFreeSubscription || hasTrialPlan ? 'Free Plan' : 'Archive Plan';
  }

  return productName;
};
